import debug from 'debug'

import Environment from '../utils/environment'

// For use when setting cookie values within environments
export const domainMap = new Map([
  ['local', 'localhost'],
  ['dev', '.acorns.io'],
  ['staging', '.acorns.io'],
  ['production', '.acorns.com'],
])

// Note: `process.env.MY_VARIABLE` get replaced at compile-time
const CONFIGURATION = {
  backend: process.env.BACKEND_URL,
  buildEnv: process.env.BUILD_ENV,
  graphql: process.env.PUBLIC_GRAPHQL,
  head: process.env.HEAD,
  helpAppUrl: process.env.PUBLIC_HELP_APP_URL,
  loginUrl: process.env.PUBLIC_SIGN_IN_APP_URL,
  webAppUrl: process.env.PUBLIC_WEB_APP_URL,
  plaidEnv: process.env.PUBLIC_PLAID_ENV,
  plaidLinkKey: process.env.PUBLIC_PLAID_KEY,
  release: (process.env.RELEASE_TAG || '').toString().trim(),
  resumeEnabled: process.env.RESUME_ENABLED,
  frontendEventProxyHost: process.env.FRONTEND_EVENT_PROXY_HOST,
  sentryUrl: process.env.SENTRY_CLIENT_DSN,
  sentryClientLogging: process.env.SENTRY_CLIENT_LOGGING,
  optimizelyEnvironment: process.env.OPTIMIZELY_ENVIRONMENT,
  optimizelyClient: process.env.OPTIMIZELY_CLIENT,
  datadogKey: process.env.DATADOG_KEY,
  signatureService: process.env.SIGNATURE_SERVICE_URL,
  titlesToRemove: process.env.TITLES_TO_REMOVE,
  testing: process.env.TESTING || false,
  rudderStackWriteKey: process.env.RUDDER_STACK_WRITE_KEY,
  rudderStackDataPlaneUrl: process.env.RUDDER_STACK_DATA_PLANE_URL,
  extoleUrl: process.env.EXTOLE_URL,
  numRequestRetries: process.env.NUM_REQUEST_RETRIES,
  requestRetryDelay: process.env.REQUEST_RETRY_DELAY,
  googlePlacesKey: process.env.GOOGLE_PLACES_API_KEY,
  dynamicFunnels: process.env.DYNAMIC_FUNNELS,
}

// Workaround due to how parcel interpolates env variables
/* istanbul ignore else */

// Note: Export an environment creator function
export default (config = CONFIGURATION) => {
  const mode = process.env.BUILD_ENV
  const logger = debug('environment')

  logger(`Running application with "${mode}" environment:`, config)

  return new Environment(config, mode)
}
